import { FC, PropsWithChildren } from 'react';

import classNames from 'classnames';

import { FormActionsInset } from './FormActions.types';

import styles from './FormActions.module.scss';

type FormActionsProps = PropsWithChildren<{
  inset?: FormActionsInset;
}>;

export const FormActions: FC<FormActionsProps> = ({
  children,
  inset = 'md',
}) => {
  return (
    <div className={classNames(styles.root, styles[inset])}>{children}</div>
  );
};
